import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RefObjectForHighchartsReact } from '../../../../CommonComponents/OPL/charts/Chart.types';
import { isCollapsedWithButtonSelector } from '../../../../ContextualSidebar/ContextualSidebarSelector';

export const useChartReflow = () => {
  const chartRef = useRef<RefObjectForHighchartsReact>(null);

  const isSidebarCollapsed = useSelector(isCollapsedWithButtonSelector);

  useEffect(() => {
    if (chartRef.current !== null) {
      chartRef.current.chart.reflow();
    }
  }, [isSidebarCollapsed]);

  return { chartRef };
};
